module.exports = __webpack_public_path__ + "img/shower.d0626750.png";